export const useGetToken = () => {
  const urlString = window.location.href;
  const url = new URL(urlString);
  const token = url.searchParams.get('token');
  return token;
};
